import Common from '../common/Common';
import tmpl from './notiTemplate';
import modal from '../components/Modal';
import { getJsonp } from '../service/fetchJsonp';
import { getIndex } from '../common/domUtil';
import { empty } from '../common/domUtil';
import '../notice/AppLink';

class NotiFriends {
    nowNode = null; // li element
    puid = null;
    prid = null;
    isLoading = false;
    listData = []; // list.json.notiResult.notiList

    constructor() {
        this.api = this.setApi();
    }

    init(data = []) { 
        const com = Common.instance;    
        this.notiL10NData = com.l10nData.Notifications;
        this.listData = data;
        this.curListData = null;

        this.addEvent();
    }

    setApi() {
        const isRc = /(rc-)/i.test(location.href) ? 'rc-' : '';
        const nowDomain = /(asia\.nc\.com)/i.test(location.href) ? 'asia.nc.com' : 'noti.plaync.com';
        const deleteNoti = `https://${isRc}${nowDomain}/noti/api/common/delete.jsonp`; //알림삭제
        const accept = `https://${isRc}sandbox.plaync.com/$!/my/friend/propose/accept.jsonp`; //친구수락
        const friendAgree = `https://${isRc}sandbox.plaync.com/$!/my/profile/updateAgreeFriendAccept.jsonp`; //약관동의
        const hideNoti = (puid, prid) => { //친구신청숨기기
            const prefix = `https://${isRc}sandbox.plaync.com`;
            return `${prefix}/$!/bns/friend/${puid}/${prid}/propose/hide.jsonp`;
        };

        return {
            deleteNoti,
            accept,
            friendAgree,
            hideNoti
        };
    }

    setNowNode(target) {
        const index = getIndex(target);
        this.curListData = this.listData?.[index];

        if(!this.curListData) {
            console.error('친구수락/숨기기 영역의 데이터가 존재하지 않습니다.');
            return;
        }

        const { publisher = {}, proposalId, id } = this.curListData || {};
        this.nowNode = target;
        this.puid = publisher?.id;
        this.prid = proposalId;
        this.nickname = publisher?.nickname;
        this.id = id;
    }

    addEvent() {
        const btAllow = document.querySelectorAll('#nc-cnb #notiList .wrapButton .btAllow');
        const btHidden = document.querySelectorAll('#nc-cnb #notiList .wrapButton .btHidden');
        const btnNcMsn = document.querySelector('#friendAgree_M .btnNcMsn');

        //수락 버튼 클릭
        if(btAllow.length > 0) {
            btAllow.forEach(v => {
                v?.addEventListener('click', e => {
                    const target = e.currentTarget;
                    const parentLi = target?.closest('li');
                    if(parentLi) {
                        this.setNowNode(parentLi);
                        this.friendAccept();
                    }
                });
            });
        }

        //숨기기 버튼 클릭
        if(btHidden.length > 0) {
            btHidden.forEach(v => {
                v?.addEventListener('click', e => {
                    const target = e.currentTarget;
                    const parentLi = target?.closest('li');
                    if(parentLi) {
                        this.setNowNode(parentLi);
                        this.friendHide();
                    }
                });
            });
        }

        //메신저 설치하기
        btnNcMsn?.addEventListener('click', e => {
            const isApp = window.npConf && window.npConf.isApp == 'true';

            if (isApp) {
                location.href = 'ncm://message?guid=' + this.puid;
            } else {
                AppLink.excute('ncm://message?guid=' + this.puid, this.nickname);
            }
        });
    }

    // 친구 수락
    friendAccept() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;

        getJsonp({
            url: this.api.accept,
            params: {
                friendId: this.puid,
                proposalId: this.prid
            }
        })
        .then(res => {
            const result = res?.result;
            this.isLoading = false;
            this.friendAcceptComp(result);
        })
        .catch(err => {
            this.isLoading = false;
        });
    }

    // 친구요청 숨기기
    async friendHide() {
        const { hideNoti, deleteNoti } = this.api || {};
        const hideNotiApi = hideNoti(this.puid, this.prid);
        
        try {
            // 친구 신청 숨기기
            await getJsonp({
                url: hideNotiApi
            });

            // 알림 삭제
            await getJsonp({
                url: deleteNoti,
                params: {
                    notiID: this.id,
                    targetCategory: 'GNB_NOTI'
                }
            });

            this.nowNode.style.display = 'none';
        } catch(err) {
            modal.openAlert({ title: this.notiL10NData.ErrorOccurred }); //알림 삭제 실패
        }
    }

    //서버응답
    async friendAcceptComp(result) {
        const notiL10NData = this.notiL10NData;

        switch(result) {
            case 'SUCCESS':
            case '4006':
                this.updateNowNodeAfterAccept();
                await modal.openAlert({ title: notiL10NData.FriendRequest });
                break;
            case 'NO_AGREEMENT_FRIEND_ACCEPT':
                this.friendAgreePop();
                break;
            case '4015':
            case '4016':
                await modal.openAlert({ title: notiL10NData.UnableAddFriends });
                break;
            case '4000':
                await modal.openAlert({ title: notiL10NData.InformationNotAvailable });
                break;
            default:
                await modal.openAlert({ title: notiL10NData.ErrorOccurred }); //친구 수락 실패
        }
    }

    //NC 친구 사용 동의 팝업
    async friendAgreePop(testNick) {
        const nick = testNick || this.nickname;
        const modalTmpl = tmpl.friendAgree_M(nick);

        const isConfirmed = await modal.openConfirm({ 
            title: modalTmpl,
            confirmButtonText: '예',
            cancelButtonText: '아니오'
        });

        if(isConfirmed) {
            getJsonp({
                url: this.api.friendAgree
            })
            .then(res => {
                const result = res?.result;        
                this.friendAgreeComp(result);
            })
            .catch(err => {
                console.log('동의 호출에 실패하였습니다.', err);
            });
        }
    }

    //팝업 동의 서버 응답
    friendAgreeComp(result) {
        if (result === 'SUCCESS') {
            setTimeout(() => {
                this.friendAccept();
            }, 150);
        } else {
            modal.openAlert({ title: this.notiL10NData.ErrorOccurred }); //'친구 동의 실패'
        }
    }

    // 친구 수락 후 Li 교체
    updateNowNodeAfterAccept() {
        const nowNode = this.nowNode;

        empty(nowNode);

        const okmsg = tmpl.tmpOkFriend(this.curListData);
        nowNode?.insertAdjacentHTML('beforeend', okmsg);
    }
}

export default new NotiFriends();

